/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Unit_KcalInputs */

const en_portal_unit_kcal = /** @type {(inputs: Portal_Unit_KcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kcal`)
};

const pl_portal_unit_kcal = /** @type {(inputs: Portal_Unit_KcalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kcal`)
};

/**
* | output |
* | --- |
* | "kcal" |
*
* @param {Portal_Unit_KcalInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_unit_kcal = /** @type {((inputs?: Portal_Unit_KcalInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Unit_KcalInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_unit_kcal(inputs)
	return en_portal_unit_kcal(inputs)
});